export const setAdmin = (state, { path, value }) => {
  state[path] = value;
};
export const setNetInvoices = (state, value) => {
  state.netInvoices = value;
};
